export default "__VITE_ASSET__e4a76ad4__"